import request from '@/utils/request'
import hotelsModule from '@/store/modules/hotels'

export default {
  orderList ({ page, orderStatus }) {
    return request({
      url: 'orders',
      params: {
        page: page,
        order_status: orderStatus
      },
      method: 'get'
    })
  },
  order (data) {
    return request({
      url: `orders/${data.orderSerial}`,
      method: 'get',
      params: {
        token: data.orderToken
      }
    })
  },
  orderCheckStatus (orderSerial) {
    return request({
      url: `orders/${orderSerial}/payments/check`,
      method: 'get'
    })
  },
  orderCoupons ({ orderSerial, code, couponId }) {
    return request({
      url: `orders/${orderSerial}/trial`,
      method: 'post',
      data: {
        code: code,
        couponId: couponId
      }
    })
  },
  createOrder (data) {
    return request({
      url: 'orders',
      method: 'post',
      data: data
    })
  },
  createOtaOrder (data) {
    return request({
      url: 'ota/orders',
      method: 'post',
      data: data
    })
  },
  updateOrderInfo (orderSerial, data) {
    return request({
      url: hotelsModule.state.externalHotelSource.includes(data.source) ? `ota/orders/${orderSerial}/info` : `orders/${orderSerial}/info`,
      method: 'post',
      data: data
    })
  },
  cancelOrderPreview (params) {
    const { orderSerial, token, source } = params
    return request({
      url: hotelsModule.state.externalHotelSource.includes(source) ? `ota/orders/${orderSerial}/cancel` : `orders/${orderSerial}/cancel`,
      method: 'get',
      params: {
        token: token
      }
    })
  },
  cancelOrder (params) {
    const { orderSerial, token, source } = params
    return request({
      url: hotelsModule.state.externalHotelSource.includes(source) ? `ota/orders/${orderSerial}/cancel` : `orders/${orderSerial}/cancel`,
      method: 'post',
      data: {
        token: token
      }
    })
  },
  experiencesList (params) {
    return request({
      url: `experiences`,
      method: 'get',
      params: params
    })
  },
  createPayment (params) {
    return request({
      url: `orders/${params.orderSerial}/payments`,
      method: 'post',
      data: params.data
    })
  },
  orderCancelReasons () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/orders/cancel/reason`,
      method: 'get'
    })
  },
  updateCancelReason (data) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/orders/cancel/reason`,
      method: 'post',
      data
    })
  },
  checkTaiwanTravelCoupon (orderSerial, data) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/orders/${orderSerial}/checkTickets`,
      method: 'post',
      data
    })
  },
  bankSpecialList () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/web/offer/payments`,
      method: 'get'
    })
  }
}
